export class BaseMasterCPN {
  matlStockItemIsn: number;
  unitUnitIsn: number;
  masterIsn: number;
  companyPartNumber: string;
  manufacturersPartNumber: string;
  manufacturersSerialNumber: string;
  companySerialNumber: string;
  aircraftNumberLocation: string;
  department: string;
  position: string;
  status: string;
  ata: number;
  originalAtaChr: string;
  ataChapter: string;
  ataSubchapter: string;
  analystAtaWildcard: string;
  effectivityCodes: string;
  quantityPerAcn: number;
  quantityPerEngine: number;
  commentsStores: string;
  commentsPlanning: string;
  commentsPurchasing: string;
  alternateCompanyPartNumber: string;
  nextHigherAssembly: string;
  lastScrDate: string;
  lastSarDate: string;
  totalQuantityScr: string;
  icUsageCur: number;
  icUsageLast: string;
  icUsagePri: string;
  totalBoh: number;
  totalFloat: string;
  totalValue: number;
  lastAtaPoSeq: string;
  lastTcjDate: Date;
  eoUsageCur: number;
  eoUsageLast: string;
  eoUsagePri: string;
  resourceCode: number;
  classCode: number;
  classCodeDescription: string;
  noun: string;
  originalDescription: string;
  description: string;
  unitIssue: string;
  planBuyCode: string;
  unhdFlag: string;
  condEffCode: string;
  smrlCodes: string;
  globallyAllocatedItemIndicator: number;
  averagePrice: number;
  primeMpn: string;
  primeFsc: string;
  primeUP: string;
  primeCF: number;
  cabAcctNumber: string;
  accountNumber: string;
  accountMethod: string;
  ataContainerNumber: string;
  inspectionRequired: string;
  trackingFlag: number;
  userField: string;
  shelfLifeTime: number;
  standardPackageQuantity: number;
  electroDischargeFlag: string;
  saveFlag: string;
  cashItemFlag: string;
  cashItemIndicator: number;
  dangerousGoodFlag: string;
  msdsFlag: string;
  rrKitFlag: string;
  bomFlag: string;
  apoFlag: string;
  tciIndicator: string;
  category23Flag: string;
  containerFlag: string;
  analystId: string;
  buyerId: string;
  requisitionedFlag: string;
  warrantyFlag: string;
  primeIatp: string;
  dangerousGoodForm: string;
  msdsId: string;
  rrKitCpn: string;
  shelfLifePeriod: string;
  authorizingEngineer: string;
  repairAnalyst: string;
  repairExpAccount: number;
  engineCpn: string;
  autoPoFlag: string;
  applicationCode: string;
  transactionName: string;
  intentCode: string;
  transactionTime: Date;
  transactionUserId: string;
  terminalId: string;
  constructTime: Date;
  moduleName: string;
  shelfLifeDomDos: string;
  shelfLifeToxicity: string;
  eptClassCode: string;
  modAnalystEmployeeNumber: string;
  addTime: Date;
  addUserId: string;
  vendorDirectShip: string;
  consignmentInventory: string;
  fixedBoh: number;
  calculatedBoh: number;
  lastUserFixedBoh: string;
  dateFixedBohChange: Date;
  directShipVendor: string;
  consignmentVendor: string;
  modsMovementQuantity: number;
  contractNumber: string;
  dsVendorLocation: string;
  dsBuyerId: string;
  dangerousGoodProperName: string;
  dangerousGoodClass: string;
  dangerousGoodRisk: number;
  dangerousGoodPackingGroup: string;
  thresholdMonths: number;
  heavyweightBulk: string;
  cpnRequestNumber: number;
  cpnRequestStatus: number;
  shelfLifeTemp: string;
  commodityTypeCode: string;
  openIctItem: string;
  openIctTime: number;
  reducedShelfLifePeriod: string;
  reducedShelfLifeTime: number;
  cpnRequiresOpSpec: string;
  sdgFlag: string;
  averagePoLeadTime: number;
  averageSoTurnTime: number;
  averageRepairCost: number;
  scrapRate: number;
  repairQuantity: number;
  serviceOrderCount: number;
  purchaseOrderCount: number;
  poLeadTimeStdDeviation: number;
  serviceOrderCountX1: number;
  soTurnTimeStdDeviation: number;
  dateFirstDemand: Date;
  tspFlag: string;
  etopsInd: string;
  structuralRepair: string;
  pooledPartFlag: string;
  timeControlledFlag: string;
  physicalPropCode: string;
  ataFormatted: number;
  length: string;
  width: string;
  height: string;
  totalWeight: string;
  aircraftPartIndicator: number;
  toolingPartIndicator: number;
  partTypeFlag: string;
  quantityServiceable: number;
  quantityInstalled: number;
  quantityUnserviceable: number;
  quantityPendingInstall: number;
  quantityServiceableWithNha: number;
  quantityInstalledWithNha: number;
  quantityUnserviceableWithNha: number;
  quantityPendingInstallWithNha: number;
  balanceOnHandControllingStation: number;
  balanceOnHandUnhd: number;
  balanceOnHandUnhdNoAssembly: number;
  balanceOnHandSurplus: number;
  balanceOnHandShop: number;
  balanceOnHandMrba: number;
  balanceOnHandVcvSars: number;
  balanceOnHandTotalInTransit: number;
  balanceOnHandServiceableInTransit: number;
  balanceOnHandUnserviceableInTransit: number;
  quantityBackorder: number;
  quantityOpenPurchaseOrder: number;
  quantityOpenServiceOrder: number;
  quantityTotalOpenOrders: number;
  totalAllocationMinQuantity: number;
  totalAllocationMaxQuantity: number;
  quantityM4UnplannedAllTime: number;
  quantityM4PlannedAllTime: number;
  quantityM4TotalAllTime: number;
  quantityMbAllTime: number;
  quantityM4Unplanned1Year: number;
  quantityM4Planned1Year: number;
  quantityM4Total1Year: number;
  quantityMb1Year: number;
  quantityM4UnplannedCurrentFiscalYr: number;
  quantityM4PlannedCurrentFiscalYr: number;
  quantityM4TotalCurrentFiscalYr: number;
  quantityMbCurrentFiscalYr: number;
  unplannedDemandQuantity36Months: number;
  averageMonthlyDemandFloat36Months: number;
  averageMonthlyDemandInteger36Months: number;
  unplannedDemandQuantity12Months: number;
  averageMonthlyDemandFloat12Months: number;
  averageMonthlyDemandInteger12Months: number;
  crossReferenceIndicator: number;
  crossReferenceCount: number;
  totalCrossReferenceCount: number;
  crossReferenceInventoryCpnCount: number;
  crossReferenceInventoryPotentialAvailable: number;
  crossReferenceInventoryUnhd: number;
  crossReferenceInventorySurplus: number;
  caseCountRogue: number;
  caseCountPrerogue: number;
  caseCountAdhoc: number;
  ataDescription: string;
  ataGroup: string;
  ataDescriptionFull: string;
  materielAtaGroup: string;
  inventoryPlanner: string;
  inventoryPlannerUsername: string;
  inventoryPlannerEmailAddress: string;
  inventoryPlannerPhoneNumber: string;
  inventoryPlannerJobTitle: string;
  dependentDemandSpecialist: string;
  dependentDemandSpecialistUsername: string;
  dependentDemandSpecialistEmailAddress: string;
  dependentDemandSpecialistPhoneNumber: string;
  dependentDemandSpecialistJobTitle: string;
  transactionControlRepair: string;
  transactionControlRepairUsername: string;
  transactionControlRepairEmailAddress: string;
  transactionControlRepairPhoneNumber: string;
  transactionControlRepairJobTitle: string;
  repairTechnicalSpecialist: string;
  repairTechnicalSpecialistUsername: string;
  repairTechnicalSpecialistEmailAddress: string;
  repairTechnicalSpecialistPhoneNumber: string;
  repairTechnicalSpecialistJobTitle: string;
  transactionControlPlanner: string;
  transactionControlPlannerUsername: string;
  transactionControlPlannerEmailAddress: string;
  transactionControlPlannerPhoneNumber: string;
  transactionControlPlannerJobTitle: string;
  dataManagementSpecialist: string;
  dataManagementSpecialistUsername: string;
  dataManagementSpecialistEmailAddress: string;
  dataManagementSpecialistPhoneNumber: string;
  dataManagementSpecialistJobTitle: string;
  engineeringSupportAnalyst: string;
  engineeringSupportAnalystUsername: string;
  engineeringSupportAnalystEmailAddress: string;
  engineeringSupportAnalystPhoneNumber: string;
  engineeringSupportAnalystJobTitle: string;
  mappsAnalyst: string;
  mappsAnalystUsername: string;
  mappsAnalystEmailAddress: string;
  mappsAnalystPhoneNumber: string;
  mappsAnalystJobTitle: string;
  warrantyAnalyst: string;
  warrantyAnalystUsername: string;
  warrantyAnalystEmailAddress: string;
  warrantyAnalystPhoneNumber: string;
  warrantyAnalystJobTitle: string;
  orderManagementSpecialist: string;
  orderManagementSpecialistUsername: string;
  orderManagementSpecialistEmailAddress: string;
  orderManagementSpecialistPhoneNumber: string;
  orderManagementSpecialistJobTitle: string;
  transactionControlOrders: string;
  transactionControlOrdersUsername: string;
  transactionControlOrdersEmailAddress: string;
  transactionControlOrdersPhoneNumber: string;
  transactionControlOrdersJobTitle: string;
  orderManagementMods: string;
  orderManagementModsUsername: string;
  orderManagementModsEmailAddress: string;
  orderManagementModsPhoneNumber: string;
  orderManagementModsJobTitle: string;
  aircraftRecordsSpecialist: string;
  aircraftRecordsSpecialistUsername: string;
  aircraftRecordsSpecialistEmailAddress: string;
  aircraftRecordsSpecialistPhoneNumber: string;
  aircraftRecordsSpecialistJobTitle: string;
  installedFleets: string;
  activeInstallCount: number;
  installedSimulatorCount: number;
  simulatorAbleCpnIndicator: number;
  unitSpecIndicator: number;
  mpnSpecIndicator: number;
  cpnHardSpecIndicator: number;
  subassemblyInstallCount: number;
  subassemblyIndicator: number;
  painCalculationTotalRemovalCount5Year: number;
  painCalculationUnscheduledRemovalCount5Year: number;
  painCalculationUnscheduledOrBfsRemovalCount5Year: number;
  totalPainCostSum5Year: number;
  unscheduledPainCostSum5Year: number;
  unscheduledOrBfsPainCostSum5Year: number;
  averageTotalPainCostPerCpn5Year: number;
  averageUnscheduledPainCostPerCpn5Year: number;
  averageUnscheduledOrBfsPainCostPerCpn5Year: number;
  averageUnscheduledPainCostPerCpnPreviousRepair5Year: number;
  averageUnscheduledOrBfsPainCostPerCpnPreviousRepair5Year: number;
  totalRemovals5Year: number;
  unscheduledCount5Year: number;
  unscheduledOrBfsCount5Year: number;
  totalM2Count5Year: number;
  unscheduledM2Count5Year: number;
  unscheduledOrBfsM2Count5Year: number;
  cpnTotalDelayRate5Year: number;
  cpnUnscheduledDelayRate5Year: number;
  cpnUnscheduledOrBfsDelayRate5Year: number;
  totalSigEventCount5Year: number;
  totalSigEventSum5Year: number;
  previousSoCost5Year: number;
  totalInstallationCost5Year: number;
  totalFlightCycles5Year: number;
  totalFlightHours5Year: number;
  totalCpnAverageCostPerFlightHour5Year: number;
  postSoUnscheduledCount5Year: number;
  postSoTsiSum5Year: number;
  postSoInstallationCost5Year: number;
  postSoCpnAverageCostPerFlightHour5Year: number;
  averageSmartTimesExcludingWarrantyRepairPrice: number;
  averagePainIndexUnscheduledRepairPrice: number;
  averagePainIndexAllRemovalRepairPrice: number;
  averageCpnTsn: number;
  averageDailyDemand: number;
  open60DayPoCount: number;
  open60DaySoCount: number;
  totalBalanceOnHandMinusBuffer: number;
  totalBalanceOnHandControlStationMinusBuffer: number;
  crtInventoryDaysOnHandWithBuffer60DayOrders: number;
  crtInventoryDaysOnHandStatusWithBuffer60DayOrders: string;
  quantityRequired60DayOnHandYellow: number;
  quantityRequired60DayOnHandGreen: number;
  crtInventoryDaysOnHandWithBuffer60DayOrdersControlStation: number;
  crtInventoryDaysOnHandStatusWithBuffer60DayOrdersControlStation: string;
  quantityRequired60DayControlStationOnHandYellow: number;
  quantityRequired60DayControlStationOnHandGreen: number;
  mechanicalPartIndicator: number;
  engineIndicator: number;
  apuIndicator: number;
  lruIndicator: number;
  crtExcludedPartIndicator: number;
  cycleDrivenPartIndicator: number;
  comparisonVictorvilleIndicator: number;
  comparisonCashIndicator: number;
  comparisonTypeCount: number;
  removedNotUnscheduledRate5Year: number;
  tsiCorruptedIndicator: number;
  ahmRmvlRate: number;
  smartTimesModelIndicator: number;
  smartTimesAtRiskQuantity: number;
  smartTimesSavingsSum: number;
  smartTimesPositiveSavingsAtRiskQuantity: number;
  smartTimesPositiveSavingsSum: number;
  aircraftFlag: string;
  painRank: number;
  soTotalCost5Year: number;
  soAverageCost5Year: number;
  so5YearCount: number;
  so5YearOrderQuantity: number;
  so5YearReceivedQuantity: number;
  po5YearCount: number;
  po5YearOrderQuantity: number;
  po5YearReceivedQuantity: number;
  dataWarehouseStartTimestamp: Date;
  dataWarehouseEndTimestamp: Date;
  dataWarehouseIsLatestFlag: string;
  logActionCode: string;
  logUserIdNumber: string;
  logTerminalIdCode: string;
  dataWarehouseLoadTimestamp: Date;
}
